import { abilitiesPlugin } from '@casl/vue'
import Vue from 'vue'

export default function ({ store }) {
  Vue.use(abilitiesPlugin, store.getters.ability)
}
